export enum NotificationTypeEnum {
  Documents = 1,
  Invoices = 2,
  Messages = 3,
  Tasks = 4,
  Requests = 5,
  Info = 6,
  Warning = 7,
  Error = 8,
  Success = 9
}
